import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

  const LAND_BLOCKED_GROUPS = [
  "building_facilities",
  "technical_equip",
  "inventories",
  "balcony",
];

// For land, only allow a few technical amenities
const LAND_ALLOWED_TECH = [
  "gas",
  "electricity",
  "warm_water",
  "cold_water"
];


   const AMENITIES_GROUPS = {
    about_locality: [
      "near_to_metro","near_to_public_transport","near_to_public_school",
      "near_to_kindergarten","near_to_recreation_area","near_to_market",
      "near_to_pharmacy","near_to_hospital","near_to_police_station",
      "near_to_sports_space","near_to_green_side","near_to_touristic_site",
      "near_to_square","near_to_park","near_to_forest","near_to_city_waters"
    ],
    building_facilities: [
      "private_parking","private_yard","private_recreation","rooftop_recreation",
      "elevator","wheelchair_accessible","free_wifi","security_service",
      "package_lockers","surveillance_camera","green_space","fitness_centre",
      "swimming_pool","spa","business_space","bike_storage","garage","baseeement"
    ],
    private_views: [
      "city_view","mountain_view","water_view","greenside_view","historic_site_view"
    ],
    technical_equip: [
      "television","internet","central_heating","cooling_system","stove","fridge",
      "microwave","dish_washer","hood","washing_machine","tumble_dryer","gas",
      "electricity","warm_water","cold_water","conditioner","priv_surveillance_camera",
      "smart_home"
    ],
    inventories: [
      "ready_to_live","furniture","household_items","decoration",
      "plant_friendly","pet_friendly","exotic_pet_friendly"
    ],
    balcony: [
      "balcony","french_balcony","closed_balcony","loggia",
      "terrace","closed_terrace","rooftop","porch"
    ]
  };

export default function AmenitiesSidebar({
  selectedAmenities,
  setSelectedAmenities,
  propertyType,
}) {
  const { t } = useTranslation();

  const allGroups = Object.keys(AMENITIES_GROUPS);

  const isLand = propertyType === "land";

  const isGroupBlocked = (group) => {
  if (!isLand) return false;

  // Only block completely if it's NOT the technical_equip group
  if (group === "technical_equip") return false;

  return LAND_BLOCKED_GROUPS.includes(group);
};

  /* 🔒 Remove blocked amenities when switching to LAND */
useEffect(() => {
  if (propertyType !== "land") return;

  const blockedAmenities = LAND_BLOCKED_GROUPS.flatMap((g) =>
    g === "technical_equip"
      ? (AMENITIES_GROUPS[g] || []).filter((item) =>
          !LAND_ALLOWED_TECH.includes(item)
        )
      : AMENITIES_GROUPS[g] || []
  );

  setSelectedAmenities((prev) =>
    prev.filter((a) => !blockedAmenities.includes(a))
  );
}, [propertyType, setSelectedAmenities]);

  const handleAmenityChange = (amenity) => {
    setSelectedAmenities((prev) =>
      prev.includes(amenity)
        ? prev.filter((x) => x !== amenity)
        : [...prev, amenity]
    );
  };


return (
  
  <div className="amenities-box">
    <h3>{t("common.amenities")}</h3>

    {allGroups
      .filter((group) => !isGroupBlocked(group))
      .map((group) => (
        <div key={group} className="amenity-group">
          <div className="group-title">
            {t(`amenities.group.${group}`)}
          </div>

          {AMENITIES_GROUPS[group]
    .filter((item) =>
    isLand && group === "technical_equip"
      ? LAND_ALLOWED_TECH.includes(item) // ✅ show only allowed
      : true
   )
   .map((item) => (
    <label key={item} className="amenity-label">
      <input
        type="checkbox"
        checked={selectedAmenities.includes(item)}
        onChange={() => handleAmenityChange(item)}
      />
      <span className="amenity-text">{t(`amenities.items.${item}`)}</span>
          </label>
         ))}
        </div>
      ))}
  </div>
 );
}
